﻿import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import {connect} from 'react-redux';

import {loadInsuranceHealthDeclarationDataAction} from './State/actions';
import {pageCurrentStepAction} from '../../State/actions';

import {getEpiData} from '../../Utils/epiHelpers';
import {mediaQuery} from '../../Style/cssHelpers';

import Loader from '../../UI/Loader';
import ErrorMessage from '../../UI/ErrorMessage';
import StepSection from '../../UI/StepSection';

import HealthDeclarationStepOne from './Components/HealthDeclarationStepOne';
import HealthDeclarationStepTwo from './Components/HealthDeclarationStepTwo';
import HealthDeclarationStepThree from './Components/HealthDeclarationStepThree';

import HealthDeclarationHeader from './Components/HealthDeclarationHeader';
import HealthDeclarationInformationBox from './Components/HealthDeclarationInformationBox';

import definitions from '../../Style/LfStyleDefinitions';

class InsuranceHealthDeclarationPage extends React.Component {
    static get propTypes() {
        return {
            mountRootId: PropTypes.string.isRequired
        }
    }

    constructor(props) {
        super(props);
        this.headerData = this.getHeaderData();
    }

    componentDidMount() {
        this.props.loadHealthDeclarationData();

        // setup back button handling, pressing it when on step 2 should gracefully step back to step1
        history.pushState({}, '', window.location.href);
        window.onpopstate = this.handleBackButton;
    }

    getHeaderData() {
        return {
            headings: [
                getEpiData('heading', this.props.mountRootId),
                getEpiData('heading-step2', this.props.mountRootId),
                getEpiData('heading-step3', this.props.mountRootId)
            ],
            preambles: [
                getEpiData('preamble', this.props.mountRootId),
                getEpiData('preamble-step2', this.props.mountRootId),
                getEpiData('preamble-step3', this.props.mountRootId)
            ]
        };
    }

    handleBackButton = (e) => {
        e.preventDefault();
        if (this.props.step == 1) {
            this.props.setCurrentStep(this.props.step - 1);
            history.pushState(null, null, window.location.href);
        } else {
            history.back();
        }
    }

    render() {
        const appliesToCoinsured = this.props.data.healthDeclarationRegistration
            && this.props.data.healthDeclarationRegistration.appliesToCoinsured == true;

        if (this.props.hasErrored) {
            const errorMsg = typeof this.props.error === 'string'
                ? this.props.error
                : this.props.error.message;

            return (
                <div>
                    <HealthDeclarationHeader
                        appliesToCoinsured={appliesToCoinsured}
                        headerData={this.headerData}
                        step={this.props.step}
                    />
                    <ErrorMessage message={`Ooops! Ett fel uppstod vid hämtningen: ${errorMsg}`} />
                </div>
            );
        }

        if (this.props.isLoading) {
            return (
                <div>
                    <HealthDeclarationHeader
                        appliesToCoinsured={appliesToCoinsured}
                        headerData={this.headerData}
                        step={this.props.step}
                    />
                    <Loader color={definitions.colors.blueBackground}/>
                </div>
            );
        }

        return (
            <div>
                <HealthDeclarationHeader
                    appliesToCoinsured={appliesToCoinsured}
                    headerData={this.headerData}
                    step={this.props.step}
                />
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                >
                    <div>
                        <StepSection sectionId={this.props.step}>
                            {this.props.step === 0 &&
                                <HealthDeclarationStepOne />
                            }

                            {this.props.step === 1 &&
                                <HealthDeclarationStepTwo />
                            }

                            {this.props.step === 2 &&
                                <HealthDeclarationStepThree />
                            }
                        </StepSection>
                    </div>
                    <HealthDeclarationInformationBox />
                </motion.div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.healthDeclarationPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading,
        step: state.pageCurrentStep
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadHealthDeclarationData: (insurance) => dispatch(loadInsuranceHealthDeclarationDataAction(insurance)),
        setCurrentStep: (step) => dispatch(pageCurrentStepAction(step))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceHealthDeclarationPage);

const Heading = styled.h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${definitions.fonts.heading};
    font-size: 60px;
    color: ${definitions.colors.almostBlack};

    border-bottom: 1px solid ${definitions.colors.grayBorder};

     ${mediaQuery.custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${mediaQuery.small(`
        border: none;
        font-size: 28px;
        padding-bottom: 0px;
        margin-bottom: 10px;
        margin-top: 31px;
    `)}
     ${mediaQuery.xxsmall(`
        font-size: 20px;
    `)}
`;

const Preamble = styled.div`
    max-width: 60%;
    margin-bottom: 40px;

    font-family: ${definitions.fonts.main};
    font-size: 20px;
    color: ${definitions.colors.almostBlack};

    ${mediaQuery.custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${mediaQuery.small(`
        margin-bottom: 15px;
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}

    ${mediaQuery.xxsmall(`
        font-size: 13px;
    `)}
`;
